// extracted by mini-css-extract-plugin
module.exports = {"icon":"Settled_icon__25-IK","content":"Settled_content__1LM6P"};